// Test IDs for the financial management SaaS multi-tenant app
export const AUTH = {
  loginForm: 'auth-login-form',
  loginEmail: 'auth-login-email',
  loginPassword: 'auth-login-password',
  loginSubmit: 'auth-login-submit',
  googleLogin: 'auth-google-login',
  goRegister: 'auth-go-register',
  registerForm: 'auth-register-form',
  registerCompany: 'auth-register-company',
  registerDocument: 'auth-register-document',
  registerName: 'auth-register-name',
  registerEmail: 'auth-register-email',
  registerPassword: 'auth-register-password',
  registerSubmit: 'auth-register-submit',
  goLogin: 'auth-go-login',
  logoutBtn: 'auth-logout-btn',
  error: 'auth-error',
};

export const NAV = {
  sidebar: 'app-sidebar',
  linkDashboard: 'nav-dashboard',
  linkTimeline: 'nav-timeline',
  linkPayable: 'nav-payable',
  linkReceivable: 'nav-receivable',
  linkAccounts: 'nav-accounts',
  linkCategories: 'nav-categories',
  linkParties: 'nav-parties',
  linkUsers: 'nav-users',
  linkReports: 'nav-reports',
  linkAudit: 'nav-audit',
  themeToggle: 'app-theme-toggle',
  userMenu: 'app-user-menu',
};

export const DASH = {
  container: 'dashboard-page',
  kpiBalance: 'kpi-balance',
  kpiIncome: 'kpi-income',
  kpiExpense: 'kpi-expense',
  kpiReceivable: 'kpi-receivable',
  kpiPayable: 'kpi-payable',
  kpiOverdue: 'kpi-overdue',
  chartCashflow: 'chart-cashflow',
  chartCategory: 'chart-category',
  listUpcoming: 'list-upcoming',
  listRecent: 'list-recent',
};

export const TX = {
  page: 'transactions-page',
  newBtn: 'transaction-new-btn',
  tabAll: 'tab-all',
  tabOverdue: 'tab-overdue',
  tabToday: 'tab-today',
  tabWeek: 'tab-week',
  tabMonth: 'tab-month',
  tabPaid: 'tab-paid',
  tabCancelled: 'tab-cancelled',
  row: (id) => `tx-row-${id}`,
  payBtn: (id) => `tx-pay-${id}`,
  cancelBtn: (id) => `tx-cancel-${id}`,
  viewBtn: (id) => `tx-view-${id}`,
  filterSearch: 'tx-filter-search',
  modalForm: 'tx-modal-form',
  modalDescription: 'tx-modal-description',
  modalAmount: 'tx-modal-amount',
  modalDue: 'tx-modal-due',
  modalCompetence: 'tx-modal-competence',
  modalAccount: 'tx-modal-account',
  modalCategory: 'tx-modal-category',
  modalParty: 'tx-modal-party',
  modalNotes: 'tx-modal-notes',
  modalSubmit: 'tx-modal-submit',
  payAmount: 'pay-modal-amount',
  payDate: 'pay-modal-date',
  payMethod: 'pay-modal-method',
  payAccount: 'pay-modal-account',
  paySubmit: 'pay-modal-submit',
};

export const TL = {
  page: 'timeline-page',
  prevMonth: 'timeline-prev',
  nextMonth: 'timeline-next',
  balanceStart: 'timeline-balance-start',
  balanceEnd: 'timeline-balance-end',
  dayGroup: (d) => `timeline-day-${d}`,
};

export const ACC = {
  page: 'accounts-page',
  newBtn: 'account-new',
  row: (id) => `account-row-${id}`,
};

export const CAT = {
  page: 'categories-page',
  newBtn: 'category-new',
};

export const PARTIES = {
  page: 'parties-page',
  newBtn: 'party-new',
};
